import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PublicRoute = ({ component: Component, ...rest }) => {
  const session_id = localStorage.getItem('techtop_user_id');

  const isLoggedIn =
    session_id !== undefined &&
    session_id !== null &&
    session_id !== '';

  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? (
          <Redirect to="/user/my-account" /> // or "/" if you prefer
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute;